


























































import { Vue, Component } from 'vue-property-decorator';
import { State } from 'vuex-class';
import { TokenMigrationStatus } from '~/store/types';

@Component
export default class TokenMigrationAlert extends Vue {
  @State('tokenMigrationStatus')
  tokenMigrationStatus!: TokenMigrationStatus;

  showBanner = false;

  get fullWidth() {
    return this.$vuetify.breakpoint.width <= 950;
  }

  get tokenMigrationActive() {
    return this.tokenMigrationStatus === TokenMigrationStatus.active;
  }

  get tokenMigrationComplete() {
    return this.tokenMigrationStatus === TokenMigrationStatus.complete;
  }

  get bannerStyle() {
    const mobileBG =
      'https://static.gala.games/images/banners/galaverse-bannermob.jpg';
    const desktopBG =
      'https://static.gala.games/images/banners/galaverse-bannerdesktop.jpg';
    const assetToUse = this.$vuetify.breakpoint.xs ? mobileBG : desktopBG;
    return {
      backgroundImage: `url('${assetToUse}')`,
    };
  }

  get bannerText() {
    const statusText = this.tokenMigrationActive
      ? 'migrationInProgressText'
      : this.tokenMigrationComplete
      ? 'migrationCompleteText'
      : '';
    return statusText
      ? this.$t(`components.promotions.tokenMigrationAlert.${statusText}`)
      : '';
  }

  mounted() {
    this.showBanner =
      (this.tokenMigrationActive &&
        !localStorage.getItem('hasSeenTokenMigrationActiveBanner')) ||
      (this.tokenMigrationComplete &&
        !localStorage.getItem('hasSeenTokenMigrationCompleteBanner'));
  }

  hideBanner() {
    this.showBanner = false;
    localStorage.setItem(
      this.tokenMigrationActive
        ? 'hasSeenTokenMigrationActiveBanner'
        : 'hasSeenTokenMigrationCompleteBanner',
      'true',
    );
  }
}
